import { types } from 'mobx-state-tree'

export const AssessmentStat = types.model('AssessmentStat').props({
  title: types.string,
  usersAssigned: types.frozen(),
  usersCompleted: types.frozen(),
  avgScore: types.number,
})
